import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { haptic } from '@/lib/haptic'
import { Toaster } from '@/components/ui/toaster'
import Home from '@/pages/Home'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import Disclaimer from '@/pages/Disclaimer'
import About from '@/pages/About'
import Leadership from '@/pages/Leadership'
import Investors from '@/pages/Investors'
import Strategy from '@/pages/Strategy'
import './index.css'

function HapticClickHandler() {
  useEffect(() => {
    const handleChange = (e: Event) => {
      if (!e.isTrusted) return
      const target = e.target as HTMLInputElement
      if (target?.type === 'checkbox') haptic()
    }
    const handleClick = (e: MouseEvent) => {
      if (!e.isTrusted) return
      const target = e.target as HTMLElement
      if (
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.getAttribute('role') === 'button' ||
        target.closest('button, a[href]')
      ) {
        haptic()
      }
    }
    document.addEventListener('change', handleChange, true)
    document.addEventListener('click', handleClick, true)
    return () => {
      document.removeEventListener('change', handleChange, true)
      document.removeEventListener('click', handleClick, true)
    }
  }, [])
  return null
}

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1)
      const el = document.getElementById(id)
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100)
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])
  return null
}

function App() {
  return (
    <Router>
      <HapticClickHandler />
      <ScrollToTop />
      <div className="min-h-screen bg-background font-sans antialiased">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/leadership" element={<Navigate to="/about/leadership" replace />} />
          <Route path="/about/leadership" element={<Leadership />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/strategy" element={<Strategy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  )
}

export default App
